import { t } from "@lingui/macro";
import * as React from "react";
import { G, Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

/** Link glyph from the POS V2.2 Figma library. */
export const LinkIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Link`} {...props}>
    <G id="Icon/16px/Lock">
      <Path
        id="Vector 339"
        d="M9.5 10.5L7.00012 12.9999C5.89548 14.1045 4.10451 14.1045 2.99988 12.9999C1.89533 11.8953 1.89522 10.1046 2.99963 8.99987L4.99926 6.99975"
        strokeWidth="1.5"
        stroke="currentColor"
      />
      <Path
        id="Vector 340"
        d="M7 5L9 3C10.1046 1.89543 11.8954 1.89543 13 3C14.1046 4.10457 14.1046 5.89543 13 7L11 9"
        strokeWidth="1.5"
        stroke="currentColor"
      />
      <Path
        id="Vector 379"
        d="M6.5 9.5L9.5 6.5"
        strokeWidth="1.5"
        stroke="currentColor"
      />
    </G>
  </Icon>
);
